import * as React from 'react';

export interface Tab {
  id: string;
  label: string;
  count?: number;
}

export interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  size?: 'sm' | 'md';
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange,
  size = 'md',
}) => {
  const paddingClass = size === 'sm' ? 'py-3' : 'py-4';

  return (
    <div className='border-b border-gray-200 px-6'>
      <nav className='-mb-px flex space-x-8'>
        {tabs.map(tab => (
          <button
            key={tab.id}
            type='button'
            onClick={() => onTabChange(tab.id)}
            className={`${paddingClass} px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.id
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
            {tab.count !== undefined && ` (${tab.count})`}
          </button>
        ))}
      </nav>
    </div>
  );
};
